import PageWidget from './PageWidget'

export default PageWidget
